export default "__VITE_ASSET__c0fc2dce__"